unable to read source [project]/packages/core/src/insertionFactory.ts